/**
 * kp-toast — the transient confirmation for a cart action.
 *
 * One element for the whole document. It sits in the layout rather than in
 * the cart because the actions it confirms are the ones that destroy and
 * re-render the cart; a toast inside a replaced region would be swept away
 * mid-animation by the very change it is announcing.
 *
 * Fire with: document.dispatchEvent(new CustomEvent('kp:toast', {
 *   detail: { message: 'Removed from cart' }
 * }));
 */
class KpToast extends HTMLElement {
  connectedCallback() {
    this.messageElement = this.querySelector('.kp-toast__message');
    this.hideTimer = null;

    this.onToast = (event) => this.show(event.detail?.message);
    document.addEventListener('kp:toast', this.onToast);
  }

  disconnectedCallback() {
    document.removeEventListener('kp:toast', this.onToast);
    clearTimeout(this.hideTimer);
  }

  show(message) {
    if (!message) return;

    // Restart the run for a second toast that lands while the first is still
    // on screen: without the reflow the animation is never re-triggered and
    // the new message inherits the old one's remaining time.
    this.hidden = true;
    this.classList.remove('kp-toast--visible');
    void this.offsetWidth;

    this.messageElement.textContent = message;
    this.hidden = false;
    this.classList.add('kp-toast--visible');

    clearTimeout(this.hideTimer);
    this.hideTimer = setTimeout(() => {
      this.classList.remove('kp-toast--visible');
      this.hidden = true;
    }, 2400);
  }
}

if (!customElements.get('kp-toast')) customElements.define('kp-toast', KpToast);
